import React from 'react'
import { PlusCircle } from 'lucide-react';
import { MoreVertical } from 'lucide-react';
import { NavLink } from 'react-router-dom';

export const ProjectForm = () => {
  return (
    <div>
        <div className="header__project">
        <h1>Проекты</h1>
        </div>

        <div className="line"></div>

        <div className="project__card">
                <div className='header__card'>
                  <NavLink className='header__card' to="/task">
                  <h3>Заголовок</h3>
                  </NavLink>
                   
                    <div className="more">    <MoreVertical /></div>
                </div>
            
                <div className="line"></div>
                <div className="card__description">
                    <h4>ОписаниеОписаниеОписаниеОп 
                    ОписаниеОписаниеОписаниеО писаниеОписа
                    ниеОписание 
                        ОписаниеОписаниеОписаниеОписани
                        еОписаниеОписание

                    </h4>
                </div>
        </div>
        <div className="project__add">
                <a> <PlusCircle /></a>
        </div>
    </div>
  )
}
